module.exports = __webpack_public_path__ + "static/media/workExperiences.4c76ead4.svg";